import { NextPage } from "next";

import InsertOfferSingpost from "scenes/InsertOfferSingpost";

const Singpost: NextPage = () => <InsertOfferSingpost />;

export default Singpost;
